.root {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  min-width: 0;
  padding: 10px 12px;
  background: var(--color-card);
  border-bottom: 1px solid var(--color-border);
}
.group { display: flex; align-items: center; gap: 4px; }
.separator { align-self: center; height: 22px; width: 1px; background: var(--color-border); margin: 0 4px; }
.input {
  margin-inline-start: auto;
  min-width: 120px;
  width: 180px;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  background: var(--color-background);
  color: var(--color-foreground);
  padding: 6px 9px;
  font: inherit;
  font-size: 13px;
  &:focus-visible { outline: 2px solid var(--color-primary); outline-offset: 2px; }
}
